import React, { useState, useEffect } from "react";
import {
  registerCandidate,
  validateWalletBalance,
  getClientPricing,
} from "../../services/user/api";
import { toast } from "react-toastify";
import "../../styles/user/addCandidatePage.css";

const AddCandidatePage = () => {
  const [candidateData, setCandidateData] = useState({
    fullname: "",
    email: "",
    dateOfBirth: "",
    mobileNumber: "",
  });

  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [redirectTimeout, setRedirectTimeout] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const [candidateType, setCandidateType] = useState("");
  const [selectedChecks, setSelectedChecks] = useState([]);
  const [pricingList, setPricingList] = useState([]);

  const checkIdMap = {
    DIGILOCKER: 1,
    CRIMINAL: 2,
    UAN: 3,
    EMPLOYMENT: 4,
  };
  const getPrice = (checkName) => {
    console.log("pricingList =", pricingList);

    const item = pricingList.find(
      (p) =>
        p.checkName?.trim().toUpperCase() === checkName.trim().toUpperCase(),
    );

    console.log("Searching", checkName, item);

    return item?.price ?? "";
  };
  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const response = await getClientPricing();

        console.log("Complete Response", response);
        console.log("Response Data", response.data);

        if (Array.isArray(response.data)) {
          setPricingList(response.data);
        } else if (Array.isArray(response.data.data)) {
          setPricingList(response.data.data);
        } else {
          console.log("Unexpected response format", response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchPricing();
  }, []);

  const handleCandidateChange = (e) => {
    const { name, value } = e.target;
    setCandidateData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFieldErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCandidateTypeChange = (type) => {
    setCandidateType(type);
    setSelectedChecks([]);
  };

  const handleCheckChange = (check) => {
    if (selectedChecks.includes(check)) {
      setSelectedChecks(selectedChecks.filter((item) => item !== check));
    } else {
      setSelectedChecks([...selectedChecks, check]);
    }
  };

  const validateFields = () => {
    const errors = {};

    // Fullname validation
    if (!candidateData.fullname?.trim()) {
      errors.fullname = "Full name is required";
    } else if (!/^[A-Za-z ]+$/.test(candidateData.fullname)) {
      errors.fullname = "Full name must contain only letters and spaces";
    } else if (candidateData.fullname.length > 40) {
      errors.fullname = "Full name should not exceed 40 characters";
    }

    // Email validation
    if (!candidateData.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(candidateData.email)) {
      errors.email = "Email format is invalid. Only @gmail.com is allowed";
    }

    // Date of Birth validation
    if (!candidateData.dateOfBirth) {
      errors.dateOfBirth = "Date of birth is required";
    } else {
      const [year, month, day] = candidateData.dateOfBirth.split("-");
      const dob = new Date(year, month - 1, day);
      const today = new Date();
      let age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      if (age < 18) {
        errors.dateOfBirth = "Age must be above 18 years";
      }
    }

    // Mobile number validation
    if (!candidateData.mobileNumber?.trim()) {
      errors.mobileNumber = "Mobile number is required";
    } else if (!/^\d{10}$/.test(candidateData.mobileNumber)) {
      errors.mobileNumber = "Mobile number must be exactly 10 digits";
    } else if (/^0/.test(candidateData.mobileNumber)) {
      errors.mobileNumber = "Mobile number should not start with 0";
    }

    if (!candidateType) {
      errors.candidateType = "Please select candidate type";
    }

    if (selectedChecks.length === 0) {
      errors.selectedChecks = "Please select at least one verification check";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;

    setLoading(true);
    try {
      const [year, month, day] = candidateData.dateOfBirth.split("-");
      const formattedData = {
        ...candidateData,
        selectedChecks: selectedChecks.map((check) => ({
          checkId: checkIdMap[check],
        })),
        dateOfBirth: `${day}-${month}-${year}`,
      };

      const validateRequest = {
        selectedChecks: selectedChecks.map((check) => ({
          checkId: checkIdMap[check],
        })),
      };

      console.log("Validate Request:", validateRequest);

      const validateResponse = await validateWalletBalance(validateRequest);

      if (!validateResponse.data.canProceed) {
        toast.error(validateResponse.data.message);
        return;
      }

      // STEP 2 : Register Candidate
      const response = await registerCandidate(formattedData);

      console.log("Register Response :", response.data);

      if (
        (response.status === 200 || response.status === 201) &&
        response.data.status === true
      ) {
        // ******** IMPORTANT ********
        // We need the Candidate ID returned by register API.
        console.log("Full Register Response :", response.data);

        // CHANGE THIS AFTER YOU SHARE THE RESPONSE
        const candidateId = response.data.data.candidateId;
        console.log("Candidate ID =", candidateId);
        toast.success(response.data.message);
        toast.success("Amount deducted successfully.");
        setSubmissionStatus("success");
      } else {
        setSubmissionStatus("error");
        setErrorMessage(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);

      const msg =
        error?.response?.data?.message ||
        "Server error occurred. Please try again.";

      if (msg.toLowerCase().includes("email")) {
        setFieldErrors((prev) => ({
          ...prev,
          email: msg,
        }));

        setSubmissionStatus(null);
      } else {
        setSubmissionStatus("error");
        setErrorMessage(msg);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSubmissionStatus(null);
    setErrorMessage("");
    if (redirectTimeout) {
      clearTimeout(redirectTimeout);
      setRedirectTimeout(null);
    }

    if (submissionStatus === "success") {
      setCandidateData({
        fullname: "",
        email: "",
        dateOfBirth: "",
        mobileNumber: "",
      });
      setFieldErrors({});
    }
  };

  return (
    <>
      <p className="profile-header">Create Login Credentials for a Candidate</p>

      <div className="add-candidate-container">
        {submissionStatus === "success" && (
          <div className="modal-overlay">
            <div className="add-success-modal">
              <h3>Candidate registered successfully!</h3>
              <button className="ok-btn" onClick={handleCloseModal}>
                OK
              </button>
            </div>
          </div>
        )}

        {submissionStatus === "error" && (
          <div className="modal-overlay">
            <div className="add-fail-modal">
              <h3>❌ Registration Failed</h3>
              <p>{errorMessage}</p>
              <button className="ok-btn" onClick={handleCloseModal}>
                OK
              </button>
            </div>
          </div>
        )}

        <div className="user-form-card">
          <div className="form-groups">
            <label>Candidate Name *</label>
            <input
              type="text"
              name="fullname"
              value={candidateData.fullname}
              onChange={handleCandidateChange}
              placeholder="Enter Candidate Name"
            />
            {fieldErrors.fullname && (
              <p className="field-error">{fieldErrors.fullname}</p>
            )}
          </div>

          <div className="form-groups">
            <label>Enter Candidate Email *</label>
            <input
              type="email"
              name="email"
              value={candidateData.email}
              onChange={handleCandidateChange}
              placeholder="Email Address"
              className={fieldErrors.email ? "input-error" : ""}
            />
            {fieldErrors.email && (
              <p className="field-error">{fieldErrors.email}</p>
            )}
          </div>

          <div className="form-groups">
            <label>Date of birth *</label>
            <input
              type="date"
              name="dateOfBirth"
              value={candidateData.dateOfBirth}
              onChange={handleCandidateChange}
            />
            {fieldErrors.dateOfBirth && (
              <p className="field-error">{fieldErrors.dateOfBirth}</p>
            )}
          </div>

          <div className="form-groups">
            <label>Mobile Number *</label>
            <input
              type="text"
              name="mobileNumber"
              value={candidateData.mobileNumber}
              onChange={handleCandidateChange}
              placeholder="Mobile number"
            />
            {fieldErrors.mobileNumber && (
              <p className="field-error">{fieldErrors.mobileNumber}</p>
            )}
          </div>
          <div className="form-groups">
            <label>Candidate Type *</label>

            <div className="checkbox-group">
              <label className="selection-card">
                <input
                  type="radio"
                  name="candidateType"
                  checked={candidateType === "FRESHER"}
                  onChange={() => handleCandidateTypeChange("FRESHER")}
                />
                <span>🎓 Fresher</span>
              </label>

              <label className="selection-card">
                <input
                  type="radio"
                  name="candidateType"
                  checked={candidateType === "EXPERIENCED"}
                  onChange={() => handleCandidateTypeChange("EXPERIENCED")}
                />
                <span>💼 Experienced</span>
              </label>
            </div>

            {fieldErrors.candidateType && (
              <p className="field-error">{fieldErrors.candidateType}</p>
            )}
          </div>

          {candidateType && (
            <div className="form-groups">
              <label>Select Verification Checks *</label>

              <div className="verification-box">
                <div className="verification-grid">
                  <label className="selection-card">
                    <input
                      type="checkbox"
                      checked={selectedChecks.includes("CRIMINAL")}
                      onChange={() => handleCheckChange("CRIMINAL")}
                    />
                    <div>
                      <span>🚔 Criminal Check</span>

                      <div className="price-text">₹ {getPrice("CRIMINAL")}</div>
                    </div>
                  </label>

                  <label className="selection-card">
                    <input
                      type="checkbox"
                      checked={selectedChecks.includes("DIGILOCKER")}
                      onChange={() => handleCheckChange("DIGILOCKER")}
                    />
                    <div>
                      <span>📂 DigiLocker</span>

                      <div className="price-text">
                        ₹ {getPrice("DIGILOCKER")}
                      </div>
                    </div>
                  </label>

                  {candidateType === "EXPERIENCED" && (
                    <>
                      <label className="selection-card">
                        <input
                          type="checkbox"
                          checked={selectedChecks.includes("UAN")}
                          onChange={() => handleCheckChange("UAN")}
                        />

                        <div>
                          <span>🆔 UAN Check</span>

                          <div className="price-text">₹ {getPrice("UAN")}</div>
                        </div>
                      </label>

                      <label className="selection-card">
                        <input
                          type="checkbox"
                          checked={selectedChecks.includes("EMPLOYMENT")}
                          onChange={() => handleCheckChange("EMPLOYMENT")}
                        />

                        <div>
                          <span>🏢 Employment Check</span>
                          <div className="price-text">
                            ₹ {getPrice("EMPLOYMENT")}
                          </div>
                        </div>
                      </label>
                    </>
                  )}
                </div>
              </div>

              {fieldErrors.selectedChecks && (
                <p className="field-error">{fieldErrors.selectedChecks}</p>
              )}
            </div>
          )}

          <button
            className="submit-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Registering..." : "Register Candidate"}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddCandidatePage;
